document.addEventListener("DOMContentLoaded", (event) => {

    const hasMap = document.querySelector('.__contact_map');
    if( hasMap ){
        let latitude = hasMap.dataset.latitude,
            longitude = hasMap.dataset.longitude;

        const map = L.map('map').setView([latitude,longitude], 16);

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);

        const LeafIcon = L.Icon.extend({
            options: {
                iconSize: [22, 30],
            }
        });

        const icon = new LeafIcon({iconUrl: '/wp-content/themes/theme_altimax/dist/img/svg/pin.svg'});

        const mGreen = L.marker([latitude,longitude], {icon: icon}).addTo(map);
    }

});
